import React from 'react'
import { Redirect, Route } from 'react-router-dom'
import { Auth } from 'aws-amplify'
import axios from 'axios'
import {getCookieValue, deleteCookie} from '../../lib/cookies'
import SessionService from '../../lib/services/SessionService'

interface Props {
    path: string;
    component: any;
    userRequired?: boolean;
  }


class AuthRoute extends React.Component<Props, any> {
    state = {
        auth: null
    }

    constructor(props: Props) {
        super(props)

        this.state = {
            auth: null
        }
    }

    //
    // Async rendering fetching external data
    //
    // See : https://reactjs.org/blog/2018/03/27/update-on-async-rendering.html#fetching-external-data
    //
    // this component will fetch current user logged from the cache or will call cognito to refresh
    // then will render the correct route
    componentDidMount() {
        console.log('*** authroute will mount. cookies: ', document.cookie)
        
       
        Auth.currentAuthenticatedUser({
            bypassCache: false // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
        })
            .then(user => {
                console.log('*** authroute loaded user', user)

                // check also signInUserSession
                if(user.signInUserSession){
                    console.log('*** authroute loaded user signInUserSession', user.signInUserSession.idToken.jwtToken)

                    axios.defaults.headers.common['Authentication'] = user.signInUserSession.idToken.jwtToken

                }


                let session = user
                if (session && session.idToken && session.idToken.jwtToken) {
                    console.log('*** authroute loaded user session.idToken.jwtToken', session.idToken.jwtToken)

                    //set token for all AXIOS REQUESTS
                    axios.defaults.headers.common['Authentication'] = session.idToken.jwtToken

                    
                    // Add masquerading header if necessary
                    let partnerMasquerading = SessionService.getPartnerLogged()
                    if (partnerMasquerading != null && partnerMasquerading.partnerId) {
                        axios.defaults.headers.common['PartnerIdMasquerading'] = partnerMasquerading.partnerId
                    }

                    // also check if we have the special cookie from seller site to app site
                    let partnerMasqueradingSeller = SessionService.getPartnerMasqueradedSeller()
                    if (partnerMasqueradingSeller!=null && partnerMasqueradingSeller.partnerId) {
                        axios.defaults.headers.common['PartnerIdMasquerading'] = partnerMasqueradingSeller.partnerId
                    }

                        
                    
                }

                // then USER signed in
                this.setState({ auth: 1 })
            })
            .catch(err => {
                console.log('Authroute mount currentAuthenticatedUser error:', err)
                this.setState({ auth: 0 })
            })
    
    


    }

    

    // conditional rendering based on state (loaded async from external api call)
    render() {
        //console.log('*** authroute render auth', this.state.auth, 'this.props.userRequired', this.props.userRequired)

        // bypass doc routing
        if (this.props && this.props.path.indexOf('/doc/') != -1) {
            return <Route {...this.props} component={this.props.component} />
        }

        // if the user is not required, then is a public route
        if (!this.props.userRequired) {
            return <Route {...this.props} component={this.props.component} />
        }

        //
        // else check the logged state of the user

        // loading state...
        if (this.state.auth === null) {
            return null
        }

        // else we have loaded async data:

        // if the user is logged:
        if (this.state.auth === 1) {
            return <Route {...this.props} component={this.props.component} />
            // else if the user is not logged:
        } else if (this.state.auth === 0) {
            if (this.props.userRequired) {
                return <Route {...this.props} component={() => <Redirect to="/signin" />} />
            } else {
                return <Route {...this.props} component={this.props.component} />
            }
        }
    }
}

export default AuthRoute
